import React, { useEffect, useState } from 'react'
import AdminSidebar from '@components/admin/AdminSidebar'
import 'twin.macro'
import BaseTable from '@components/shared/BaseTable'
import { QueryFunctionContext, useQuery, useQueryClient } from 'react-query'
import { api } from '@api/index'
import usePagenation from '@hooks/usePagenation'
import { useNavigate } from 'react-router-dom'
import { FieldValues, useForm } from 'react-hook-form'

const rowSize = 8

const fetchUserList = ({ queryKey }: QueryFunctionContext) => {
  const [_, page, searchKeyword] = queryKey
  return api.adminService.getUserList({
    size: rowSize,
    page: (page as number) - 1, //서버측 pageIndex는 0부터 시작
    sort: 'id,desc',
    search: searchKeyword as PagenationSearchOption<UserInfo>,
  })
}

const AdminUserManagement = () => {
  const [searchKeyword, setSearchKeyword] =
    useState<PagenationSearchOption<UserInfo>>('username,')
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<any>({
    mode: 'onChange',
  })

  const {
    pagelist,
    currentPage,
    goBeforeSection,
    goNextSection,
    goNext,
    goBefore,
    setListRefIndex,
    setTotalPage,
  } = usePagenation(5)

  const {
    isLoading,
    error,
    data: { totalPages, content } = {} as UserPagenationInfo,
  } = useQuery(['UserList', currentPage, searchKeyword], fetchUserList, {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setTotalPage(data.totalPages)
    },
  })

  useEffect(() => {
    const nextPage = currentPage + 1
    if (nextPage > totalPages) return
    queryClient.prefetchQuery(
      ['UserList', nextPage, searchKeyword],
      fetchUserList
    )
  }, [currentPage, queryClient, totalPages, searchKeyword])

  const handleUserListRowClick = (uuid: number) => {
    navigate(`/admin/user-management/${uuid}`)
  }

  const handleSearchClick = (form: FieldValues) => {
    setSearchKeyword(`username,${form.searchKeyword}`)
  }

  return (
    <>
      <form onSubmit={handleSubmit(handleSearchClick)}>
        <section tw="w-1200 flex gap-32">
          <AdminSidebar />
          <main tw="w-full ">
            <h1 tw="text-2xl border-b-2 font-bold pb-10 border-neutral-400">
              유저관리
            </h1>
            <div tw="flex justify-end items-center gap-3 mt-20">
              <input
                {...register('searchKeyword')}
                tw="w-200"
                className="input"
                placeholder="아이디 입력"
              />
              <button className="button base">검색</button>
            </div>
            <div tw="py-20">
              <BaseTable
                column={[
                  ['번호', 5],
                  ['아이디', 5],
                  ['닉네임', 5],
                  ['연락처', 6],
                ]}
              >
                {content?.map(({ id, nickname, phone, username }) => (
                  <tr
                    onClick={() => handleUserListRowClick(id)}
                    key={id}
                    tw="cursor-pointer hover:bg-neutral-200"
                  >
                    <td>{id}</td>
                    <td>{username}</td>
                    <td>{nickname}</td>
                    <td>{phone}</td>
                  </tr>
                ))}
              </BaseTable>
            </div>
            <div tw="w-full flex justify-center gap-8 mt-10">
              {' '}
              <button
                type="button"
                className="button base"
                onClick={goBeforeSection}
              >
                {'<<'}
              </button>
              <button type="button" className="button base" onClick={goBefore}>
                {'<'}
              </button>
              {pagelist.map((num, idx) => (
                <button
                  type="button"
                  className="button base"
                  onClick={() => setListRefIndex(idx)}
                  key={num}
                >
                  {num}
                </button>
              ))}
              <button type="button" className="button base" onClick={goNext}>
                {'>'}
              </button>
              <button
                type="button"
                className="button base"
                onClick={goNextSection}
              >
                {'>>'}
              </button>
            </div>
          </main>
        </section>
      </form>
    </>
  )
}

export default AdminUserManagement
